import { render, staticRenderFns } from "./UserScramblePage.vue?vue&type=template&id=dab6d24e&scoped=true"
import script from "./UserScramblePage.vue?vue&type=script&lang=js"
export * from "./UserScramblePage.vue?vue&type=script&lang=js"
import style0 from "./UserScramblePage.vue?vue&type=style&index=0&id=dab6d24e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab6d24e",
  null
  
)

export default component.exports